import { MaIcon, type IconName } from "./MaIcon";

interface Props {
  icon: IconName;
  onClick?: () => void;
  size?: number;
  dark?: boolean;
  label?: string;
}

export function MaCircleButton({ icon, onClick, size = 40, dark = false, label }: Props) {
  return (
    <button onClick={onClick} aria-label={label ?? icon} style={{
      width: size, height: size, borderRadius: "50%",
      border: "var(--ma-border) solid var(--ma-ink)",
      background: dark ? "var(--ma-ink)" : "var(--ma-cream)",
      color: dark ? "var(--ma-paper)" : "var(--ma-ink)",
      display: "flex", alignItems: "center", justifyContent: "center",
      cursor: "pointer", padding: 0, flexShrink: 0,
    }}>
      <MaIcon name={icon} size={size * 0.5} />
    </button>
  );
}
